import { call, takeEvery } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App, MeasureType, UnderwriterDecision } from '@ps20-frontend/frontend-models';
import { DashboardAction, DashboardActions } from '../dashboard.actions';

export function* watchUwDecisionSubmitted() {
  yield takeEvery(
    DashboardActions.UW_DECISION_SUBMITTED,
    safeSaga(handleUwDecisionSubmitted, App.SHOP_DASHBOARD)
  );
}

export function* handleUwDecisionSubmitted(action: DashboardAction<UnderwriterDecision[]>) {
  const decisions: UnderwriterDecision[] = action.payload;
  const globalActions = new GlobalActions();
  const globalPut = GlobalPut.getInstance();

  const decisionsPerAngebot = decisions.filter(
    (decision, index) =>
      decisions.findIndex(
        candidate =>
          candidate.appId === decision.appId && candidate.angebotsId === decision.angebotsId,
      ) === index,
  );

  for (const decision of decisionsPerAngebot) {
    const zuschlagMassnahme = decision.massnahmen?.find(m => m.type === MeasureType.ZUSCHLAG);
    const zuschlaegeFaktor = zuschlagMassnahme?.zuschlagProzent > 0
      ? 1 + zuschlagMassnahme.zuschlagProzent / 100
      : 1;
      yield call(
        globalPut.put,
        globalActions.zuschlaegeFaktorReceived({
          appId: decision.appId,
          angebotsId: decision.angebotsId,
          zuschlaegeFaktor: zuschlaegeFaktor,
        })
      );

      yield call(
        globalPut.put,
        globalActions.tarifiereAngebotForShop(decision.appId, decision.angebotsId)
      );

  }
}
